// extracted by mini-css-extract-plugin
export default {"container":"field-label_container__3qy32"};